import api from '@/api';

export const innkModel = {
    state: {
        data: {},
        error: false,
        loading: false,
    },
    reducers: {
        // Remove
        setInnk: (state, payload) => {
            return { ...state, data: { ...state.data, [payload.id]: payload.data } };
        },
        setError: (state, payload) => {
            return { ...state, error: payload };
        },
    },
    effects: dispatch => ({
        async loadInnk(wellId, rootState) {
            this.loading = true;
            try {
                const raw = await api.carottage.fetchInnk({ wellIds: [wellId] });

                let res = [];
                if (Array.isArray(raw[wellId])) {
                    res = raw[wellId];
                }

                // const dummyRes = [
                //     {
                //         id: 1,
                //         type: 'ИННК',
                //         top: 100,
                //         bottom: 101,
                //         value: 1.0,
                //         valueAbs: 1.1,
                //         dateStart: new Date(2007, 7, 18),
                //         dateEnd: new Date(2007, 7, 20),
                //         saturation: 1, // 1 - вода, 2 - нефть, 3 - газ, 4 - нефть+вода, 0 - неопределено
                //         lithology: 1, // 1 - песчанник, 0 - неопределенно
                //         tabs: {
                //             studyParameters: {
                //                 'Заказчик': 'ООО “Лукойл-Пермь”',
                //                 'Филиал заказчика': '',
                //                 'Цех заказчика': 'ЦДНГ-3 УралОйл',
                //                 'Исполнитель': 'ОАО “Пермнефтегеофизика”',
                //                 'Полевая партия': '11',
                //                 'Начальник партии': 'Миргунов В.Н.',
                //                 'Категория скважины': 'Нефтяная',
                //                 'Состояние скважины': '',
                //                 'Процесс при использовании скважины': 'Перфорация',
                //                 'Диаметр кондуктора': '245',
                //                 'Глубина спуска кондуктора': '284',
                //                 'Дата цементажа': '02.10.1983',
                //                 'Высота подъема цемента': '19',
                //                 'Интерпретатор (автор заключения)': 'Гиниятов Г.З.',
                //                 'Геол. индекс объекта разработки': 'Тл',
                //                 'Тип прибора': 'АИНК-43; Сова-3',
                //                 'Номер прибора': '1;18',
                //                 'Мнемоника предмета исследования': 'ВНК Текущий',
                //                 'Мнемоника типа данных': 'Увязанные по глубине',
                //                 'Перечень геологических задач исследования': 'Определение текущего характера насыщения',
                //                 'Перечень работ исследуемой скважины': 'Импульсный нейрон-нейронный каротаж',
                //                 'Режим работы исследуемой скважины': 'В остановленной скважине',
                //                 'Дата исследования': '02.02.2008',
                //                 'Дата выдачи заключения': '04.02.2008',
                //                 'Толщина стенок колонны': '6.Б-9.8',
                //             },
                //             intervals: [
                //                 {
                //                     number: '1.',
                //                     top: '1488.0',
                //                     bottom: '1488.0',
                //                     oilSaturation: '77',
                //                     porosity: '-',
                //                     saturation: '-',
                //                     clayContent: '-',
                //                     lithology: '-',
                //                     object: '-',
                //                     effectivePower: '-',
                //                     lifetimeWarmNeurons: '-',
                //                 },
                //                 {
                //                     number: '2.',
                //                     top: '1488.0',
                //                     bottom: '1488.0',
                //                     oilSaturation: '77',
                //                     porosity: '-',
                //                     saturation: '-',
                //                     clayContent: '-',
                //                     lithology: '-',
                //                     object: '-',
                //                     effectivePower: '-',
                //                     lifetimeWarmNeurons: '-',
                //                 },
                //             ],
                //         },
                //     },
                //     {
                //         id: 2,
                //         type: 'ИГН',
                //         top: 120,
                //         bottom: 125,
                //         value: 5.0,
                //         valueAbs: 6.1,
                //         dateStart: new Date(2007, 7, 21),
                //         dateEnd: new Date(2007, 7, 22),
                //         saturation: 4, // 1 - вода, 2 - нефть, 3 - газ, 4 - нефть+вода, 0 - неопределено
                //         lithology: 0, // 1 - песчанник, 0 - неопределенно
                //         tabs: {
                //             studyParameters: {
                //                 'Заказчик': 'ООО “Лукойл-Пермь”',
                //                 'Филиал заказчика': '',
                //                 'Цех заказчика': 'ЦДНГ-3 УралОйл',
                //                 'Исполнитель': 'ОАО “Пермнефтегеофизика”',
                //                 'Полевая партия': '11',
                //                 'Начальник партии': 'Миргунов В.Н.',
                //                 'Категория скважины': 'Нефтяная',
                //                 'Состояние скважины': '',
                //                 'Процесс при использовании скважины': 'Перфорация',
                //                 'Диаметр кондуктора': '245',
                //                 'Глубина спуска кондуктора': '284',
                //                 'Дата цементажа': '02.10.1983',
                //                 'Высота подъема цемента': '19',
                //                 'Интерпретатор (автор заключения)': 'Гиниятов Г.З.',
                //                 'Геол. индекс объекта разработки': 'Тл',
                //                 'Тип прибора': 'АИНК-43; Сова-3',
                //                 'Номер прибора': '1;18',
                //                 'Мнемоника предмета исследования': 'ВНК Текущий',
                //                 'Мнемоника типа данных': 'Увязанные по глубине',
                //                 'Перечень геологических задач исследования': 'Определение текущего характера насыщения',
                //                 'Перечень работ исследуемой скважины': 'Импульсный нейрон-нейронный каротаж',
                //                 'Режим работы исследуемой скважины': 'В остановленной скважине',
                //                 'Дата исследования': '02.02.2008',
                //                 'Дата выдачи заключения': '04.02.2008',
                //                 'Толщина стенок колонны': '6.Б-9.8',
                //             },
                //             intervals: [
                //                 {
                //                     number: '1.',
                //                     top: '1488.0',
                //                     bottom: '1488.0',
                //                     oilSaturation: '77',
                //                     porosity: '-',
                //                     saturation: '-',
                //                     clayContent: '-',
                //                     lithology: '-',
                //                     object: '-',
                //                     effectivePower: '-',
                //                     lifetimeWarmNeurons: '-',
                //                 },
                //                 {
                //                     number: '2.',
                //                     top: '1488.0',
                //                     bottom: '1488.0',
                //                     oilSaturation: '77',
                //                     porosity: '-',
                //                     saturation: '-',
                //                     clayContent: '-',
                //                     lithology: '-',
                //                     object: '-',
                //                     effectivePower: '-',
                //                     lifetimeWarmNeurons: '-',
                //                 },
                //             ],
                //         },
                //     },
                // ];

                this.setInnk({ id: wellId, data: res });
                this.loading = false;
            } catch (error) {
                this.setError(error);
                this.loading = false;
                console.log(error);
            }
        },
    }),
};
